export default __webpack_public_path__ + "static/media/washupStep4.bf959586.png";